import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import Checkbox from '../../Checkbox.js';
import DateInput from '../../DateInput.js';
import Input from '../../Input.js';
const EConomicSettings = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement("label", null,
            React.createElement("p", null, lang.integrations.importAllText),
            React.createElement(Checkbox, { checked: props.options.importAllInvoices, onChange: (e) => {
                    props.setOptions({
                        ...props.options,
                        importAllInvoices: e.target.checked,
                    });
                } })),
        React.createElement("label", null,
            React.createElement("p", null, lang.integrations.cutoffDateText),
            React.createElement(DateInput, { placeholder: lang.misc.date, value: props.options.afterDate ? moment(props.options.afterDate) : null, allowNull: true, onChange: (date) => {
                    const d = date != null ? date.toJSON() : null;
                    props.setOptions({ ...props.options, afterDate: d });
                } })),
        React.createElement("label", null,
            React.createElement("p", null, props.options.importAllInvoices
                ? lang.integrations.invoiceDate
                : lang.integrations.dueDate),
            React.createElement(Input, { value: props.options.importAfterDays, onChange: (e) => {
                    const val = parseInt(e.target.value);
                    if (Number.isNaN(val) || val < 0) {
                        return;
                    }
                    props.setOptions({ ...props.options, importAfterDays: val });
                }, type: "number", placeholder: lang.misc.days, min: "0", max: "180" })),
        React.createElement("label", null,
            React.createElement("p", null, lang.integrations.updateCustomers),
            React.createElement(Checkbox, { checked: props.options.updateCustomers, onChange: (e) => {
                    props.setOptions({
                        ...props.options,
                        updateCustomers: e.target.checked,
                    });
                } }))));
};
export default EConomicSettings;
//# sourceMappingURL=EConomicSettings.js.map